import vanillaLazyLoad from 'vanilla-lazyload';

var lazyLoadInstance = new vanillaLazyLoad({
    elements_selector: '.lazyload',
    container_selector: '.lazyload__wrap',
});

lazyLoadInstance.update();



// WEBPACK FOOTER //
// ./scripts/autoload/vanilla-lazyload.js